<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb :crumbs="[$t('action.pickingCheck')]"></breadcrumb>
      <div class="container">
        <div class="pd20">
          <el-form ref="pickingForm" :model="pickingObj">
            <el-row>
              <el-col :span="20">
                <div class="center" style="width: 500px; margin: 0 auto">
                  <el-form-item
                    :prop="'serialNoTracking'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [
                          $t('delivery.serialNoTracking'),
                        ]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      id="serialNo"
                      v-model="pickingObj.serialNoTracking"
                      :placeholder="$t('delivery.scanSerialNoTracking')"
                      autofocus
                      @keypress.enter.native="enterKeyUpSerialNoTracking"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :prop="'product'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [
                          $t('product.productNo'),
                        ]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      id="product"
                      v-model="pickingObj.product"
                      :placeholder="'扫描产品吊牌二维码'"
                      autofocus
                      clearable
                      @keypress.enter.native="enterKeyUpProduct"
                    ></el-input>
                  </el-form-item>
                  <div>
                    <el-table :data="orders" size="mini" border>
                      <el-table-column
                        prop="productNo"
                        :label="$t('product.productNo')"
                      />
                      <el-table-column
                        prop="color"
                        :label="$t('product.color')"
                      />
                      <el-table-column
                        prop="size"
                        :label="$t('product.size')"
                      />
                      <el-table-column
                        prop="presentDeliverQuantity"
                        :label="$t('text.quantity')"
                        width="50"
                      />
                      <el-table-column
                        prop="verifyQty"
                        :label="'扫描数量'"
                        width="80"
                      >
                        <template slot-scope="scope">
                          <span
                            :class="
                              scope.row.verifyQty !=
                              scope.row.presentDeliverQuantity
                                ? 'red'
                                : ''
                            "
                            >{{ scope.row.verifyQty }}</span
                          >
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="verifyQty"
                        :label="'核对结果'"
                        width="80"
                      >
                        <template slot-scope="scope">
                          <span v-if="!enterKeyUpProductDF"> 未校验 </span>
                          <span v-else>
                            <span
                              v-if="
                                scope.row.verifyQty ==
                                scope.row.presentDeliverQuantity
                              "
                              class="green expand-field-title"
                              >正确</span
                            >
                            <span
                              v-if="
                                scope.row.verifyQty !=
                                scope.row.presentDeliverQuantity
                              "
                              class="red expand-field-title"
                              >错误</span
                            >
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-if="abnormalInfos.length != 0" class="mt20">
                    <div class="red mgb10 mgt10">匹配不到的数据：</div>
                    <el-table :data="abnormalInfos" size="mini" border>
                      <el-table-column
                        prop="productNo"
                        :label="$t('product.productNo')"
                      />
                      <el-table-column
                        prop="color"
                        :label="$t('product.color')"
                      />
                      <el-table-column
                        prop="size"
                        :label="$t('product.size')"
                      />
                      <el-table-column
                        prop="verifyQty"
                        :label="'扫描数量'"
                        width="80"
                      />
                    </el-table>
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="left" style="margin-top: 50px">
                  <div style="font-size: 20px" class="mgb10">
                    总&nbsp;数&nbsp;量&nbsp;：{{ countScanTotal() }}
                  </div>
                  <div style="font-size: 20px" class="orange">
                    扫描数量：{{ countCheckTotal }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="form-footer">
          <el-button type="primary" size="medium" plain @click="checkFinish">
            校验完成
          </el-button>
          <el-button type="warning" size="medium" plain @click="clearData">
            清空数据
          </el-button>
          <back-button />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import BackButton from "@/components/BackButton";
import Delivery from "@/api/delivery.js";
import WorkOrder from "@/api/workOrder.js";

export default {
  mixins: [page],
  components: { BackButton },
  data() {
    return {
      saveDoing: false,
      pickingObj: {
        serialNoTracking: null,
        product: null,
      },
      orders: [],
      abnormalInfos: [],
      enterKeyUpProductDF: false,
      //
      countCheckTotal: 0,
      delivery: null,
    };
  },

  computed: {},
  created() {
    const self = this;
  },
  methods: {
    countScanTotal() {
      let total = 0;
      if (this.orders.length === 0) {
        return 0;
      }
      this.orders.map((i) => {
        total += Number(i.quantity);
      });
      return total;
    },
    //
    checkFinish() {
      const self = this;
      if (self.delivery != null) {
        Delivery.check(self.delivery.id).then(function (res) {
          if (res.status == 200) {
            self.$message({
              message: self.$t("prompt.deliveryCheckSuccess"),
              type: "warning",
            });
            self.clearData();
          } else {
            self.sysError();
          }
        });
      }
    },
    enterKeyUpSerialNoTracking() {
      const self = this;
      self.enterKeyUpProductDF = false;
      self.pickingObj.product = null;
      self.delivery = null;
      self.abnormalInfos = [];
      Delivery.findBySerialNoOrTracking({
        serialNoTracking: Util.qrcodeAnalysis(
          self.pickingObj.serialNoTracking,
          "serialNo"
        ),
      }).then(function (res) {
        if (res.status === 200) {
          if (res.data.length !== 0) {
            // 每次取最新的一条发货记录
            self.delivery = res.data[res.data.length - 1];
            const orders = self.delivery.orders;
            if (orders != null && orders.length !== 0) {
              self.orders = orders;
              for (const order of self.orders) {
                Vue.set(order, "verifyQty", 0);
              }
              document.getElementById("product").focus();
            } else {
              self.delivery = null;
              self.$message({
                message: "该发货单号下没有订单",
                type: "warning",
              });
            }
          } else {
            self.delivery = null;
            self.$message({
              message: self.$t("prompt.deliverySerialNoNotExist"),
              type: "warning",
            });
          }
        } else {
          self.sysError();
        }
      });
    },
    enterKeyUpProduct() {
      const self = this;
      // console.log(
      //   "====enterKeyUpProduct",
      //   self.pickingObj.product.substring(0, 7)
      // );
      self.enterKeyUpProductDF = true;
      const productNo = Util.qrcodeAnalysis(
        self.pickingObj.product,
        "productNo"
      );
      const color = Util.qrcodeAnalysis(self.pickingObj.product, "color");
      const size = Util.qrcodeAnalysis(self.pickingObj.product, "size");
      self.enterKeyUpProductCompute(productNo, color, size);
      self.pickingObj.product = null;
    },
    enterKeyUpProductCompute(productNo, color, size) {
      const self = this;
      this.countCheckTotal = this.countCheckTotal + 1;
      for (const order of self.orders) {
        if (
          order.productNo == productNo &&
          order.color == color &&
          order.size == size &&
          order.verifyQty < order.presentDeliverQuantity
        ) {
          order.verifyQty = order.verifyQty + 1;
          return;
        }
        if (
          order.productNo == productNo &&
          order.verifyQty < order.presentDeliverQuantity
        ) {
          order.verifyQty = order.verifyQty + 1;
          return;
        }
        //======
        if (
          self.abnormalInfos.length != 0 &&
          self.abnormalInfos.find(
            (ab) =>
              ab.productNo == productNo && ab.color == color && ab.size == size
          ) != null
        ) {
          for (const ab of self.abnormalInfos) {
            if (
              ab.productNo == productNo &&
              ab.color == color &&
              ab.size == size
            ) {
              ab.verifyQty = ab.verifyQty + 1;
              return;
            }
          }
        }
        self.abnormalInfos = self.abnormalInfos.concat([
          {
            productNo: productNo,
            color: color,
            size: size,
            verifyQty: 1,
          },
        ]);
      }
      self.pickingObj.product = null;
    },

    clearData() {
      const self = this;
      self.delivery = null;
      self.countCheckTotal = null;
      self.pickingObj.serialNoTracking = null;
      self.pickingObj.product = null;
      self.abnormalInfos = [];
      self.orders = [];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>